import { useEffect, useEffectEvent } from 'react';
import type {
  TaskArrivalNotification,
  TaskAssigneeChangedNotification,
} from 'types/pushNotifications';

export type TaskArrivalEvent =
  | { kind: 'task-arrived'; task: TaskArrivalNotification }
  | { kind: 'assignee-changed'; task: TaskAssigneeChangedNotification };

type TaskArrivalListener = (event: TaskArrivalEvent) => void;

const listeners = new Set<TaskArrivalListener>();

export const emitTaskArrival = (task: TaskArrivalNotification) => {
  listeners.forEach((listener) => listener({ kind: 'task-arrived', task }));
};

export const emitTaskAssigneeChange = (task: TaskAssigneeChangedNotification) => {
  listeners.forEach((listener) => listener({ kind: 'assignee-changed', task }));
};

export const useTaskArrivals = (onTaskArrival: TaskArrivalListener) => {
  const notifyTaskArrival = useEffectEvent(onTaskArrival);

  useEffect(() => {
    const listener = (event: TaskArrivalEvent) => notifyTaskArrival(event);

    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  }, []);
};
